import Vue from 'vue'
import router from './router'
import store from './store'
import { Modal, notification } from 'ant-design-vue';
import { IAppModel, IMenuModel, IUserLoginInfoModel } from "src/model";
import { tools } from "utils"
import { constantRouterMap } from './router/router.config'

// 无默认首页的情况
const defaultRoutePath = '/shop'
const whiteList = ['login', 'register', 'registerResult',"shop"] 

router.beforeEach((to: any, from: any, next: any) =>
{
  
    if (localStorage.getItem("accessToken"))
    {
        // 用户已登入
        if (to.path === '/login')
        {
            next({ path: defaultRoutePath});
        }
        else
        {
            let profile: IUserLoginInfoModel = store.getters['user/profile']
            if(!store.getters["global/isLogin"] && profile)
            {
                // 拿菜单信息
                let app_menu = localStorage.getItem("app_menu");
                let antDesignmenus
                if (!app_menu)
                {
                    const applocation: Array<any> = [];
                    // 应用信息
                    profile && profile.apps.forEach((item: IAppModel) =>
                    {
                        const apps:{
                            code: string,
                            name: string,
                            active: boolean,
                            menu: Array<IMenuModel>
                        } = { code: '', name: '', active: true, menu: [] }
                        if (item.active) {
                            apps.code = item.code
                            apps.name = item.name
                            apps.active = item.active
                            apps.menu = profile.menus
                            antDesignmenus = profile.menus
                        } else {
                            apps.code = item.code
                            apps.name = item.name
                            apps.active = item.active
                            apps.menu = []
                        }
                        applocation.push(apps)
                    })
                    // 存储菜单缓存信息
                    localStorage.setItem("app_menu", JSON.stringify(applocation))
                }
                else
                {
                    // 取缓存数据
                    antDesignmenus = app_menu && JSON.parse(app_menu)&&JSON.parse(app_menu)[0] && JSON.parse(app_menu)[0].menu || [];
                }

                // store.commit("global/SET_IS_LOGIN", 1);
                
                store.dispatch('global/generateRoutes', antDesignmenus).then(() =>
                {
                    // 动态添加可访问路由表
                    router.addRoutes(store.getters["global/menuData"])
                    // 请求带有 redirect 重定向时，登录自动重定向到该地址
                    const redirect = decodeURIComponent(from.query.redirect || to.path)
                    // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                    if (to.path === redirect) {
                        next({ path: redirect })
                        // // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                        next({ ...to, replace: true })
                    } else {
                        // 跳转到目的路由
                        next({path: redirect})
                    }
                })
            }
            else
            {
                next();
            }   
        }
    } else {
        if (whiteList.includes(to.name)) {
        // 在免登录白名单，直接进入
        next()
        } else {
            next({ path: '/login' })
        }
    }
})
